import apiTrainerResult from '@/api/trainer-result'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: 0,
}

export const mutationTypes = {
  getTrainerResultStart:
    '[trainer result by id] Get trainer result by id start',
  getTrainerResultSuccess:
    '[trainer result by id] Get trainer result by id success',
  getTrainerResultFailure:
    '[trainer result by id] Get trainer result by id failure',
}

export const actionTypes = {
  getTrainerResult: '[trainer result by id] Get trainer by id result',
}

const mutations = {
  [mutationTypes.getTrainerResultStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getTrainerResultSuccess](state, payload) {
    state.data = payload.data ? payload.data : payload
    state.total = payload.total ? payload.total : 0
    state.isLoading = false
  },

  [mutationTypes.getTrainerResultFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getTrainerResult](context, {params}) {
    context.commit(mutationTypes.getTrainerResultStart)
    return new Promise((resolve) => {
      apiTrainerResult
        .getTrainersResultById(params)
        .then((response) => {
          const result = response.data ? response.data : response
          context.commit(mutationTypes.getTrainerResultSuccess, response)
          resolve(result)
        })
        .catch((error) => {
          context.commit(mutationTypes.getTrainerResultFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
